import { sectorService } from "@features/sector/SectorService";
import { SectorOutputDTO } from '@features/sector/types';
import createEntitySlice from "@services/createEntitySlice";

const {
  reducer: SectorReducer,
  actions: SectorActions,
  fetchAll: fetchSectors,
  fetchById: fetchSectorById,
  createEntity: createSector,
  updateEntity: updateSector,
  deleteEntity: deleteSector,
} = createEntitySlice<SectorOutputDTO>("Sector", sectorService);

export {
  SectorReducer,
  SectorActions,
  fetchSectors,
  fetchSectorById,
  createSector,
  updateSector,
  deleteSector,
}; 